import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

import { Box, Row, Text, Img } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { defaultVideoArt } from "../../theme/image";

const Wrapper = styled(Row)`
  width: 100%;
  height: 60px;
  align-items: center;
  padding-left: 2px;
  padding-right: 2px;
  &:hover {
    background: ${({ theme }) => theme.color.BLACK_1};
  }
  cursor: pointer;
`;

export default ({
  playlist: { id, name, thumbnail },
  onSelect,
}) => {
  const onClick = () => {
    onSelect(id);
  };
  return (
    <Wrapper onClick={onClick}>
      <Img height="90%" src={thumbnail || defaultVideoArt} />
      <Text
        marginLeft="5%"
        fontSize="16px"
        fontWeight="520"
        oneline={true}
        color={Theme.textColor.light}
      >
        {name}
      </Text>
    </Wrapper>
  );
};
